<script>
import CommonMixin from './CommonMixin';

export default {
  name: 'ThanksRoute',
  mixins: [CommonMixin],
};
</script>

<template lang="pug">
PanelContainer.panel(id="thankspanel", :modal="true")
  ThanksBoxConnected
</template>

<style scoped>
.panel {
  width: 400px;
  flex-shrink: 0;
  margin-right: 100px;
}
</style>
